import { render, staticRenderFns } from "./WidthFilter.vue?vue&type=template&id=08b6eb08&scoped=true&"
import script from "./WidthFilter.vue?vue&type=script&lang=js&"
export * from "./WidthFilter.vue?vue&type=script&lang=js&"
import style0 from "./WidthFilter.vue?vue&type=style&index=0&id=08b6eb08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6eb08",
  null
  
)

export default component.exports